<div class="filter-panel--option form--apto-ionic-select">
    <ion-label stacked>{{ label }}</ion-label>
    <apto-ionic-select [options]="getOptions()"
                       [value]="selectedOption"
                       placeholder="Select option"
                       (onSelectOption)="setSelected($event.value)"></apto-ionic-select>
</div>
